<template>
  <b-modal
    centered
    id="import-modal"
    footer-class="border-top-none"
    header-class="border-bottom-none"
    ref="modalImport"
    size="xl"
    :title="'Import ' + title"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <div class="row align-items-center pl-3 pr-3">
      <div class="d-flex align-items-center" v-if="!showTabArea">
        <span>Vui lòng sử dụng file template này để Import dữ liệu!</span>
        <base-button
          class="ml-3"
          button="Tải file Template"
          @click="downloadTemplate"
        ></base-button>
      </div>
      <div class="ml-auto" v-else>
        <base-button button="Hủy" class="m-0" @click="refreshDataPreview" />
      </div>
    </div>
    <div class="row align-items-center">
      <div
        class="btn-choose-file m-3"
        @click="chonFile"
        v-if="!showTabArea"
        :disabled="isLoading"
      >
        Vui lòng chọn tập tin .xlsx để import...
      </div>
      <div>
        <VueFileAgent
          ref="UploadFileImportNhiemVu"
          class="d-none btn-upload-file"
          :uploadHeaders="{}"
          :theme="'list'"
          :multiple="false"
          :linkable="true"
          :deletable="true"
          :meta="true"
          :accept="'.xlsx'"
          v-model="fileUpload"
          @select="fileSelected($event)"
        >
          <template v-slot:after-inner>
            <label>
              <span>
                <b-icon icon="upload" class="tai-len-file cursor-pointer" />
              </span>
              Import
            </label>
          </template>
        </VueFileAgent>
      </div>
    </div>
    <div class="pd-warning" style="margin-bottom: 0" v-if="!showTabArea">
      <span class="font-weight-bold">Chú ý!</span>
      <ul style="margin-bottom: 0">
        <li>Phải sử dụng file Excel mẫu ở trên để nhập.</li>
        <li>Không được để trống những cột có dấu *.</li>
      </ul>
    </div>
    <div
      class="row ml-1 mr-1 mt-2"
      v-if="message && message.length"
      :class="isSuccess ? 'text-black' : 'text-red'"
    >
      <p v-html="message"></p>
    </div>
    <div class="mt-3 tabs-area" v-if="showTabArea">
      <b-tabs>
        <b-tab
          title="Cấp đơn vị"
          v-if="
            this.dataType === IMPORT_TYPE.CapDonVi ||
            this.dataType === IMPORT_TYPE.Multi
          "
        >
          <div
            class="row ml-1 mr-1 mt-2"
            v-if="messageCapDonVi && messageCapDonVi.length"
            :class="isSuccessCapDonVi ? 'text-black' : 'text-red'"
          >
            <p v-html="messageCapDonVi"></p>
          </div>
          <DataTable
            class="p-datatable-customers"
            :value="internalCapDonViData"
            :rowClass="rowClass"
          >
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <Column
              field="index"
              header="STT"
              headerStyle="width: 50px"
              bodyStyle="padding: 0 !important"
            >
              <template #body="slotProps">
                <div class="text-center">{{ slotProps.data.rowIndex - 2 }}</div>
              </template>
            </Column>
            <Column
              v-for="(col, index) in FIELD_IMPORT.CAP_DON_VI"
              :key="index"
              :field="col.key"
              :header="col.value"
            >
              <template #filter>
                <InputText
                  v-if="col.keySearch"
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  @change="searchData(IMPORT_TYPE.CapDonVi)"
                  v-model="requestCapDonVi[col.keySearch]"
                />
              </template>
              <template #body="slotProps">
                <div class="text-center">
                  <span>{{ slotProps.data[col.key] }}</span>
                </div>
              </template>
            </Column>
          </DataTable>
          <BasePagination
            class="mt-3"
            :current-page="requestCapDonVi.pageIndex"
            :total-pages="requestCapDonVi.totalPages"
            :page-size-prop="requestCapDonVi.pageSize"
            :total-rows="requestCapDonVi.totalRows"
            @changeNum="onChangeNumCapDonVi($event)"
            @changePages="onChangePagesCapDonVi($event)"
          ></BasePagination>
        </b-tab>
        <b-tab
          title="Nhóm chức vụ"
          v-if="
            this.dataType === IMPORT_TYPE.NhomChucVu ||
            this.dataType === IMPORT_TYPE.Multi
          "
        >
          <div
            class="row ml-1 mr-1 mt-2"
            v-if="messageNhomChucVu && messageNhomChucVu.length"
            :class="isSuccessNhomChucVu ? 'text-black' : 'text-red'"
          >
            <p v-html="messageNhomChucVu"></p>
          </div>
          <DataTable
            class="p-datatable-customers"
            :value="internalNhomChucVuData"
            :rowClass="rowClass"
          >
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <Column
              field="index"
              header="STT"
              headerStyle="width: 50px"
              bodyStyle="padding: 0 !important"
            >
              <template #body="slotProps">
                <div class="text-center">{{ slotProps.data.rowIndex - 2}}</div>
              </template>
            </Column>
            <Column
              v-for="(col, index) in FIELD_IMPORT.NHOM_CHUC_VU"
              :key="index"
              :field="col.key"
              :header="col.value"
            >
              <template #filter>
                <InputText
                  v-if="col.keySearch"
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  @change="searchData(IMPORT_TYPE.NhomChucVu)"
                  v-model="requestNhomChucVu[col.keySearch]"
                />
              </template>
              <template #body="slotProps">
                <div class="text-center">
                  <span>{{ slotProps.data[col.key] }}</span>
                </div>
              </template>
            </Column>
          </DataTable>
          <BasePagination
            class="mt-3"
            :current-page="requestNhomChucVu.pageIndex"
            :total-pages="requestNhomChucVu.totalPages"
            :page-size-prop="requestNhomChucVu.pageSize"
            :total-rows="requestNhomChucVu.totalRows"
            @changeNum="onChangeNumNhomChucVu($event)"
            @changePages="onChangePagesNhomChucVu($event)"
          ></BasePagination>
        </b-tab>
        <b-tab
          title="Chức vụ"
          v-if="
            this.dataType === IMPORT_TYPE.ChucVu ||
            this.dataType === IMPORT_TYPE.Multi
          "
        >
          <div
            class="row ml-1 mr-1 mt-2"
            v-if="messageChucVu && messageChucVu.length"
            :class="isSuccessChucVu ? 'text-black' : 'text-red'"
          >
            <p v-html="messageChucVu"></p>
          </div>
          <DataTable
            class="p-datatable-customers"
            :value="internalChucVuData"
            :rowClass="rowClass"
          >
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <Column
              field="index"
              header="STT"
              headerStyle="width: 50px"
              bodyStyle="padding: 0 !important"
            >
              <template #body="slotProps">
                <div class="text-center">{{ slotProps.data.rowIndex -2 }}</div>
              </template>
            </Column>
            <Column
              v-for="(col, index) in FIELD_IMPORT.CHUC_VU"
              :key="index"
              :field="col.key"
              :header="col.value"
            >
              <template #filter>
                <InputText
                  v-if="col.keySearch"
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestChucVu[col.keySearch]"
                  @change="searchData(IMPORT_TYPE.ChucVu)"
                />
              </template>
              <template #body="slotProps">
                <div class="text-center">
                  <span>{{ slotProps.data[col.key] }}</span>
                </div>
              </template>
            </Column>
          </DataTable>
          <BasePagination
            class="mt-3"
            :current-page="requestChucVu.pageIndex"
            :total-pages="requestChucVu.totalPages"
            :page-size-prop="requestNhomChucVu.pageSize"
            :total-rows="requestChucVu.totalRows"
            @changeNum="onChangeNumChucVu($event)"
            @changePages="onChangePagesChucVu($event)"
          ></BasePagination
        ></b-tab>
        <b-tab
          title="Đơn vị"
          v-if="
            this.dataType === IMPORT_TYPE.DonVi ||
            this.dataType === IMPORT_TYPE.Multi
          "
        >
          <div
            class="row ml-1 mr-1 mt-2"
            v-if="messageDonVi && messageDonVi.length"
            :class="isSuccessDonVi ? 'text-black' : 'text-red'"
          >
            <p v-html="messageDonVi"></p>
          </div>
          <DataTable
            class="p-datatable-customers-canbo-donvi break-word"
            :value="internalDonViData"
            :rowClass="rowClass"
          >
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <Column
              field="index"
              header="STT"
              headerStyle="width: 60px"
              bodyStyle="padding: 0 !important"
            >
              <template #body="slotProps">
                <div class="text-center">{{ slotProps.data.rowIndex -2 }}</div>
              </template>
            </Column>
            <Column
              v-for="(col, index) in FIELD_IMPORT.DON_VI"
              :key="index"
              :field="col.key"
              :header="col.value"
            >
              <template
                v-if="
                  col.key === DON_VI_FIELD_IMPORT.LaDonViAo ||
                  col.key === DON_VI_FIELD_IMPORT.LaDonViNgoai ||
                  col.key === DON_VI_FIELD_IMPORT.DiaChiTheoDonViCha
                "
                #filter
              >
                <v-select
                  :multiple="false"
                  v-model="requestDonVi[col.keySearch]"
                  :options="FILTER_TRUE_FALSE"
                  required
                  :clearable="false"
                  label="label"
                  :reduce="(name) => name.key"
                  @input="searchData(IMPORT_TYPE.DonVi)"
                >
                </v-select>
              </template>
              <template v-else #filter>
                <InputText
                  v-if="col.keySearch"
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestDonVi[col.keySearch]"
                  @change="searchData(IMPORT_TYPE.DonVi)"
                />
              </template>
              <template #body="slotProps">
                <div class="text-center">
                  <span>{{ slotProps.data[col.key] }}</span>
                </div>
              </template>
            </Column>
          </DataTable>
          <BasePagination
            class="mt-3"
            :current-page="requestDonVi.pageIndex"
            :total-pages="requestDonVi.totalPages"
            :page-size-prop="requestNhomChucVu.pageSize"
            :total-rows="requestDonVi.totalRows"
            @changeNum="onChangeNumDonVi($event)"
            @changePages="onChangePagesDonVi($event)"
          ></BasePagination
        ></b-tab>
        <b-tab
          title="Cán bộ"
          v-if="
            this.dataType === IMPORT_TYPE.CanBo ||
            this.dataType === IMPORT_TYPE.Multi
          "
        >
          <div
            class="row ml-1 mr-1 mt-2"
            v-if="messageCanBo && messageCanBo.length"
            :class="isSuccessCanBo ? 'text-black' : 'text-red'"
          >
            <p v-html="messageCanBo"></p>
          </div>
          <DataTable
            class="p-datatable-customers-canbo-donvi break-word"
            :value="internalCanBoData"
            :rowClass="rowClass"
          >
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <Column
              field="index"
              header="STT"
              headerStyle="width: 60px"
              bodyStyle="padding: 0 !important"
            >
              <template #body="slotProps">
                <div class="text-center">{{ slotProps.data.rowIndex - 3}}</div>
              </template>
            </Column>
            <Column
              v-for="(col, index) in FIELD_IMPORT.CAN_BO"
              :key="index"
              :field="col.key"
              :header="col.value"
            >
              <template
                v-if="col.key === CAN_BO_FIELD_IMPORT.LanhDaoDonVi"
                #filter
              >
                <v-select
                  :multiple="false"
                  v-model="requestCanBo[col.keySearch]"
                  :options="FILTER_TRUE_FALSE"
                  required
                  :clearable="false"
                  label="label"
                  :reduce="(name) => name.key"
                  @input="searchData(IMPORT_TYPE.CanBo)"
                >
                </v-select>
              </template>
              <template
                v-else-if="col.key === CAN_BO_FIELD_IMPORT.NgaySinh"
                #filter
              >
                <date-picker
                  format="DD/MM/YYYY"
                  class="d-block w-100 custom-input"
                  placeholder="Chọn ngày"
                  v-model="requestCanBo[col.keySearch]"
                  range
                  @change="searchData(IMPORT_TYPE.CanBo)"
                ></date-picker>
              </template>
              <template v-else #filter>
                <InputText
                  v-if="col.keySearch"
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestCanBo[col.keySearch]"
                  @change="searchData(IMPORT_TYPE.CanBo)"
                />
              </template>
              <template
                v-if="col.key === CAN_BO_FIELD_IMPORT.NgaySinh"
                #body="slotProps"
              >
                <div class="text-center">
                  <span>{{ format(slotProps.data[col.key]) }}</span>
                </div>
              </template>
              <template v-else #body="slotProps">
                <div class="text-center">
                  <span>{{ slotProps.data[col.key] }}</span>
                </div>
              </template>
            </Column>
          </DataTable>
          <BasePagination
            class="mt-3"
            :current-page="requestCanBo.pageIndex"
            :total-pages="requestCanBo.totalPages"
            :page-size-prop="requestNhomChucVu.pageSize"
            :total-rows="requestCanBo.totalRows"
            @changeNum="onChangeNumCanBo($event)"
            @changePages="onChangePagesCanBo($event)"
          ></BasePagination
        ></b-tab>
      </b-tabs>
    </div>
    <template v-slot:modal-footer>
      <div class="d-flex">
        <base-button
          button="Import"
          @click="importData"
          :disabled="isLoading || disableThaoTac || !choPhepImport"
        />
        <base-button
          @click="hideModal()"
          class="btn btn-line"
          button="Đóng"
          :disabled="isLoading"
        >
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { showMsgOk, showMsgError } from "@/utils/commonUtils";
import readXlsxFile from "read-excel-file";
import { removeAccents } from "@/utils/normalize";
import ENDPOINT from "@/api/endpoints";
import {
  IMPORT_TYPE,
  CAN_BO_FIELD_IMPORT,
  FILTER_TRUE_FALSE,
  DON_VI_FIELD_IMPORT,
} from "@/constants/constants";
import Import from "@/mixins/Import";
import BasePagination from "@/components/common/BasePagination";
export default {
  name: "ModalUploadImportFile",
  components: {
    BasePagination,
  },
  mixins: [Import],
  props: {
    title: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | null,
      required: true,
    },
    dataType: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | null,
      required: true,
    },
  },
  data() {
    return {
      IMPORT_TYPE,
      CAN_BO_FIELD_IMPORT,
      DON_VI_FIELD_IMPORT,
      FILTER_TRUE_FALSE,
      fileName: "Vui lòng chọn tập tin .xlsx để import...",
      isLoading: false,
      showTabArea: false,
      fileImport: null,
      fileUpload: null,
      disableThaoTac: true,
      nhomChucVuData: [],
      capDonViData: [],
      chucVuData: [],
      donViData: [],
      canBoData: [],
      internalNhomChucVuData: [],
      internalCapDonViData: [],
      internalChucVuData: [],
      internalDonViData: [],
      internalCanBoData: [],
      message: "",
      isSuccess: true,
      messageCapDonVi: "",
      isSuccessCapDonVi: true,
      messageNhomChucVu: "",
      isSuccessNhomChucVu: true,
      messageChucVu: "",
      isSuccessChucVu: true,
      messageDonVi: "",
      isSuccessDonVi: true,
      messageCanBo: "",
      isSuccessCanBo: true,
    };
  },
  computed: {
    hasData() {
      let hasData = false;
      if (this.dataType == IMPORT_TYPE.CapDonVi) {
        hasData = this.capDonViData && this.capDonViData.length;
      } else if (this.dataType == IMPORT_TYPE.NhomChucVu) {
        hasData = this.nhomChucVuData && this.nhomChucVuData.length;
      } else if (this.dataType == IMPORT_TYPE.ChucVu) {
        hasData = this.chucVuData && this.chucVuData.length;
      } else if (this.dataType == IMPORT_TYPE.DonVi) {
        hasData = this.donViData && this.donViData.length;
      } else if (this.dataType == IMPORT_TYPE.CanBo) {
        hasData = this.canBoData && this.canBoData.length;
      } else if (this.dataType == IMPORT_TYPE.Multi) {
        hasData =
          (this.capDonViData && this.capDonViData.length) ||
          (this.nhomChucVuData && this.nhomChucVuData.length) ||
          (this.chucVuData && this.chucVuData.length) ||
          (this.donViData && this.donViData.length) ||
          (this.canBoData && this.canBoData.length);
      }
      return hasData;
    },
    choPhepImport() {
      let isSuccess =
        this.isSuccess &&
        this.isSuccessCapDonVi &&
        this.isSuccessNhomChucVu &&
        this.isSuccessChucVu &&
        this.isSuccessChucVu &&
        this.isSuccessDonVi &&
        this.isSuccessCanBo;
      return isSuccess && this.hasData;
    },
  },
  watch: {
    hasData: {
      handler() {
        if (!this.hasData && this.fileImport) {
          this.message = "Không có dữ liệu trong file Import";
          this.isSuccess = false;
        }
        //else {
        // this.message = "";
        // this.isSuccess = true;
        //}
      },
      deep: true,
    },
  },
  methods: {
    showModal() {
      this.refreshDataError();
      this.refreshDataPreview();
      this.$refs.modalImport.show();
    },
    refreshDataPreview() {
      this.fileImport = null;
      this.disableThaoTac = true;
      this.showTabArea = false;
      this.capDonViData = [];
      this.nhomChucVuData = [];
      this.chucVuData = [];
      this.donViData = [];
      this.canBoData = [];
      this.internalCapDonViData = [];
      this.internalNhomChucVuData = [];
      this.internalChucVuData = [];
      this.internalDonViData = [];
      this.internalCanBoData = [];
      this.message = "";
      this.isSuccess = true;
      this.messageNhomChucVu = "";
      this.isSuccessNhomChucVu = true;
      this.messageChucVu = "";
      this.isSuccessChucVu = true;
      this.messageDonVi = "";
      this.isSuccessDonVi = true;
      this.messageCanBo = "";
      this.isSuccessCanBo = true;
    },
    rowClass(rowData) {
      if (rowData.isError) {
        return "row-error";
      }
      if (rowData.isErrorServer) {
        return "row-error";
      }
      return "";
    },
    hideModal() {
      this.fileName = "Vui lòng chọn tập tin .xlsx để import...";
      this.isLoading = false;
      this.message = "";
      this.fileImport = null;
      this.isSuccess = true;
      this.disableThaoTac = true;
      this.$refs["modalImport"].hide();
    },
    refreshData() {
      this.$emit("refreshData", true);
    },
    markErrorRows(dataType, responseData) {
      if (dataType == IMPORT_TYPE.CapDonVi) {
        this.isSuccessCapDonVi = responseData.isSuccess;
        this.messageCapDonVi = responseData.message;
      }
      if (dataType == IMPORT_TYPE.NhomChucVu) {
        this.isSuccessNhomChucVu = responseData.isSuccess;
        this.messageNhomChucVu = responseData.message;
      } else if (dataType == IMPORT_TYPE.ChucVu) {
        this.isSuccessChucVu = responseData.isSuccess;
        this.messageChucVu = responseData.message;
      } else if (dataType == IMPORT_TYPE.DonVi) {
        this.isSuccessDonVi = responseData.isSuccess;
        this.messageDonVi = responseData.message;
      } else if (dataType == IMPORT_TYPE.CanBo) {
        this.isSuccessCanBo = responseData.isSuccess;
        this.messageCanBo = responseData.message;
      } else if (dataType == IMPORT_TYPE.Multi) {
        this.isSuccess = responseData.isSuccess;
        this.message = responseData.message;
      }
      this.capDonViData
        .filter((x) => responseData.listCapDonViRowError.includes(x.rowIndex))
        .forEach((item) => (item.isErrorServer = true));
      this.nhomChucVuData
        .filter((x) => responseData.listNhomChucVuRowError.includes(x.rowIndex))
        .forEach((item) => (item.isErrorServer = true));
      this.chucVuData
        .filter((x) => responseData.listChucVuRowError.includes(x.rowIndex))
        .forEach((item) => (item.isErrorServer = true));
      this.donViData
        .filter((x) => responseData.listDonViRowError.includes(x.rowIndex))
        .forEach((item) => (item.isErrorServer = true));
      this.canBoData
        .filter((x) => responseData.listCanBoRowError.includes(x.rowIndex))
        .forEach((item) => (item.isErrorServer = true));
    },
    importData() {
      let endpoint = "";
      switch (this.dataType) {
        case IMPORT_TYPE.CapDonVi: {
          endpoint = ENDPOINT.IMPORT.CAP_DON_VI;
          break;
        }
        case IMPORT_TYPE.ChucVu: {
          endpoint = ENDPOINT.IMPORT.CHUC_VU;
          break;
        }
        case IMPORT_TYPE.NhomChucVu: {
          endpoint = ENDPOINT.IMPORT.NHOM_CHUC_VU;
          break;
        }
        case IMPORT_TYPE.DonVi: {
          endpoint = ENDPOINT.IMPORT.DON_VI;
          break;
        }
        case IMPORT_TYPE.CanBo: {
          endpoint = ENDPOINT.IMPORT.CAN_BO_USER;
          break;
        }
        case IMPORT_TYPE.Multi: {
          endpoint = ENDPOINT.IMPORT.MULTI;
          break;
        }
      }
      this.isLoading = true;
      this.disableThaoTac = true;
      this.$store
        .dispatch("importService/importData", {
          endPoint: endpoint,
          data: this.getPayload(this.dataType),
        })
        .then((res) => {
          this.isLoading = false;
          if (res.data.isSuccess) {
            if (this.dataType != "Multi") showMsgOk("Import thành công!");
            else showMsgOk("Thao tác thành công");
            this.isSuccess = true;
            this.refreshData();
          } else {
            this.isSuccess = false;
            showMsgError("Import thất bại!");
          }
          this.markErrorRows(this.dataType, res.data);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    },
    async fileSelected(fileSelected) {
      this.showTabArea = false;
      if (fileSelected) {
        this.fileName = fileSelected[0].file.name;
        this.fileImport = fileSelected[0];
        this.message = "";
        this.disableThaoTac = false;
        if (
          this.fileImport.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.message = "Chỉ nhấp nhận file có định dạng .xlsx";
          this.isSuccess = false;
          this.$toasted.global.showErrorMessage({
            message: "Chỉ nhấp nhận file có định dạng .xlsx",
          });
          return;
        } else {
          this.message = "";
          this.isSuccess = true;
        }
        this.readFile();
      }
    },
    async readFile() {
      let sheets = [];
      //Get sheets
      try {
        await readXlsxFile(this.fileImport.file, { getSheets: true }).then(
          (sheetsOfFile) => {
            sheetsOfFile.forEach((element) => {
              sheets.push(
                removeAccents(element.name, true).replaceAll(" ", "")
              );
            });
          }
        );
      } catch (error) {
        this.isLoading = false;
        console.error(error);
      }

      //ReadFile + Get Index
      if (this.dataType === IMPORT_TYPE.Multi) {
        let indexCapDonVi = sheets.indexOf(
          removeAccents(IMPORT_TYPE.CapDonVi, true).replaceAll(" ", "")
        );
        let indexNhomChucVu = sheets.indexOf(
          removeAccents(IMPORT_TYPE.NhomChucVu, true).replaceAll(" ", "")
        );
        let indexChucVu = sheets.indexOf(
          removeAccents(IMPORT_TYPE.ChucVu, true).replaceAll(" ", "")
        );
        let indexDonVi = sheets.indexOf(
          removeAccents(IMPORT_TYPE.DonVi, true).replaceAll(" ", "")
        );
        let indexCanBo = sheets.indexOf(
          removeAccents(IMPORT_TYPE.CanBo, true).replaceAll(" ", "")
        );

        if (
          [
            indexNhomChucVu,
            indexChucVu,
            indexDonVi,
            indexCanBo,
            indexCapDonVi,
          ].includes(-1)
        ) {
          let errorSheet = [];
          if (indexNhomChucVu === -1) {
            errorSheet.push("Nhóm chức vụ");
          }
          if (indexCapDonVi === -1) {
            errorSheet.push("Cấp đơn vị");
          }
          if (indexChucVu === -1) {
            errorSheet.push("Chức vụ");
          }
          if (indexDonVi === -1) {
            errorSheet.push("Đơn vị");
          }
          if (indexCanBo === -1) {
            errorSheet.push("Cán bộ");
          }
          this.message = `Không tìm thấy sheet ${errorSheet.join(
            ", "
          )}, vui lòng sử dụng file template`;
          this.isSuccess = false;
          return;
        }
        this.refreshDataError();
        let rawDataCapDonVi = await this.readSheet(
          indexCapDonVi,
          IMPORT_TYPE.CapDonVi
        );
        let dataCapDonVi = this.convertToListData(
          rawDataCapDonVi,
          IMPORT_TYPE.CapDonVi
        );
        let rawDataNhomChucVu = await this.readSheet(
          indexNhomChucVu,
          IMPORT_TYPE.NhomChucVu
        );
        let rawDataChucVu = await this.readSheet(
          indexChucVu,
          IMPORT_TYPE.ChucVu
        );
        let rawDataDonVi = await this.readSheet(indexDonVi, IMPORT_TYPE.DonVi);
        let rawDataCanBo = await this.readSheet(indexCanBo, IMPORT_TYPE.CanBo);
        let dataNhomChucVu = this.convertToListData(
          rawDataNhomChucVu,
          IMPORT_TYPE.NhomChucVu
        );
        let dataChucVu = this.convertToListData(
          rawDataChucVu,
          IMPORT_TYPE.ChucVu
        );
        let dataDonVi = this.convertToListData(rawDataDonVi, IMPORT_TYPE.DonVi);
        let dataCanBo = this.convertToListData(rawDataCanBo, IMPORT_TYPE.CanBo);

        this.validateData(dataCapDonVi, IMPORT_TYPE.CapDonVi);
        this.validateData(dataNhomChucVu, IMPORT_TYPE.NhomChucVu);
        this.validateData(dataChucVu, IMPORT_TYPE.ChucVu);
        this.validateData(dataDonVi, IMPORT_TYPE.DonVi);
        this.validateData(dataCanBo, IMPORT_TYPE.CanBo);

        this.setDataToList(IMPORT_TYPE.CapDonVi, dataCapDonVi);
        this.setDataToList(IMPORT_TYPE.NhomChucVu, dataNhomChucVu);
        this.setDataToList(IMPORT_TYPE.ChucVu, dataChucVu);
        this.setDataToList(IMPORT_TYPE.DonVi, dataDonVi);
        this.setDataToList(IMPORT_TYPE.CanBo, dataCanBo);

        this.isSuccess =
          this.isSuccessCapDonVi &&
          this.isSuccessNhomChucVu &&
          this.isSuccessChucVu &&
          this.isSuccessDonVi &&
          this.isSuccessCanBo;
        if (!this.isSuccess) {
          let errorSheet = [];
          if (!this.isSuccessNhomChucVu) {
            errorSheet.push("Nhóm chức vụ");
          }
          if (!this.isSuccessCapDonVi) {
            errorSheet.push("Cấp đơn vị");
          }
          if (!this.isSuccessChucVu) {
            errorSheet.push("Chức vụ");
          }
          if (!this.isSuccessDonVi) {
            errorSheet.push("Đơn vị");
          }
          if (!this.isSuccessCanBo) {
            errorSheet.push("Cán bộ");
          }

          this.message = `Có lỗi ở sheet ${errorSheet.join(
            ", "
          )}, vui lòng kiểm tra lại dữ liệu`;
        }
      } else {
        let index = sheets.indexOf(
          removeAccents(this.dataType, true).replaceAll(" ", "")
        );
        this.refreshDataError();
        let rawData = await this.readSheet(index, this.dataType);
        let listData = this.convertToListData(rawData, this.dataType);
        if (listData && listData.length) {
          this.validateData(listData, this.dataType);
          this.setDataToList(this.dataType, listData);
        }
      }
      if (!this.getHeaderErrorText()) {
        this.showTabArea = true;
      }
    },
    async readSheet(index, dataType) {
      let sheetData;
      if (index === -1) {
        this.message = `Không tìm thấy sheet ${dataType}, vui lòng sử dụng file template`;
        this.isSuccess = false;
        return;
      } else {
        index += 1;
      }
      try {
        await readXlsxFile(this.fileImport.file, { sheet: index }).then(
          (rows) => {
            sheetData = rows;
          }
        );
        this.checkHeader(dataType, sheetData);
        return sheetData;
      } catch (error) {
        this.isLoading = false;
        console.error(error);
      }
    },
    chonFile() {
      document.querySelector(".btn-upload-file input[type=file]").click();
    },
    downloadTemplate() {
      window.open("/template/TemplateImportData.xlsx", "_blank");
    },
  },
};
</script>

<style lang="scss" >
.p-datatable-customers-canbo-donvi {
  overflow: auto;
  tr {
    th {
      width: 150px;
    }
    th:nth-child(7) {
      width: 200px;
    }
    th:last-child {
      width: 160px;
    }
  }
}
.break-word {
  word-break: break-word;
}
#import-modal .modal-header .close {
  display: none;
}
.btn-choose-file {
  width: 100%;
  text-align: center;
  border: 2px dashed rgba(0, 0, 0, 0.2);
  padding: 10px;
  cursor: pointer;
}
.no-wrap {
  width: calc(100% - 150px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-red {
  color: red;
}
.text-black {
  color: black;
}
.vue-file-agent {
  &.file-input-wrapper {
    border: none !important;
  }
  .file-preview-new {
    svg {
      fill: #1a62b3 !important;
    }
  }
}
</style>>

